import { DangerousGoodLabel } from '@hazmatsuite-next/ui';
import { EnumPackageType } from './package-type.enum';
import { InnerPackagingModel } from './inner-packaging.model';

export class SinglePackagingModel extends InnerPackagingModel {
  override PackageType: EnumPackageType.SinglePacking | EnumPackageType.Bulk | EnumPackageType.Tank = EnumPackageType.SinglePacking;

  IsConstructionSiteTankEnabled = false;
  DefaultShippingExpression = '';
  UseAlternativeProperShippingName = false;
  UseAlternativePackagingType = false;
  AlternativeProperShippingName = '';
  IsTechnicalNameRequired = false;
  TechnicalName = '';

  UpperFlashpoint = '';
  LowerFlashpoint = '';

  HasExemptionQuantity = false;
  TransportCategory = '';
  ExemptionQuantitySum = '';

  DangerousGoodLabelImageList: DangerousGoodLabel[] = [];
}
